import React, { useContext } from 'react';

import SelectedPlanContext from '../../context/SelectedPlan';
import './InfoWidget.scss';

/**
 * Component for showing financial details of the currently selected plan
 *
 * @component
 * @example
 * const type = "currentPlan"; // type can have possible values of "currentPlan" or "dueToday"
 * return (
 *   <InfoWidget type={type} />
 * )
*/

const InfoWidget = ({ type }) => {

    const { selectedPlan } = useContext(SelectedPlanContext)

    return (
        <div className="infoWidget text-white px-5 py-2 rounded w-50 text-center d-flex flex-column align-items-center justify-content-start">

            {type === "currentPlan" && (
                <>
                    <p className="text-nowrap">Current Plan</p>
                    <p>
                        
                        {selectedPlan.metadata.price_for_fe ? (
                            <>
                                <span className="currentPlanPrice">${selectedPlan.name === "Personal" ? 0.00 : selectedPlan.metadata.price_for_fe}</span>
                                <span className="currentPlanFrequency">/month</span>
                            </>
                        ) : (<span className="currentPlanPrice">Free</span>)}

                    </p>
                    <p className="currentPlan text-nowrap">{selectedPlan.name} Plan</p>

                </>
            )}

            {type === "dueToday" && (
                <>
                    <p className="text-nowrap">Due Today</p>
                    <p className="currentPlanPrice">
                        ${selectedPlan.metadata.price_for_fe}
                    </p>
                </>
            )}

        </div>
    )

}

export default InfoWidget;